// Helpers to add an appointment to Google / Apple / Outlook calendars (client-side only).

const COMPANY = "Rehabilitated For Life SSM";
const DEFAULT_DURATION_MIN = 60;

// Build local Date from "YYYY-MM-DD" + "HH:MM"
const toLocalDate = (dateStr, timeStr) => {
  const [y, m, d] = (dateStr || "").split("-").map(Number);
  const [h, min] = (timeStr || "00:00").split(":").map(Number);
  return new Date(y, (m || 1) - 1, d || 1, h || 0, min || 0, 0);
};

// Format a Date as floating local time YYYYMMDDTHHMMSS (no timezone => shown as entered).
const fmtFloating = (dt) =>
  `${dt.getFullYear()}${String(dt.getMonth() + 1).padStart(2, "0")}${String(dt.getDate()).padStart(2, "0")}T` +
  `${String(dt.getHours()).padStart(2, "0")}${String(dt.getMinutes()).padStart(2, "0")}00`;

const eventFields = (appt) => {
  const start = toLocalDate(appt.date, appt.time);
  const end = new Date(start.getTime() + DEFAULT_DURATION_MIN * 60000);
  const title = `${appt.type || "Appointment"} · ${COMPANY}`;
  const url = appt.meetingUrl || appt.meeting_url || "";
  const descParts = [];
  if (appt.notes) descParts.push(appt.notes);
  if (url) descParts.push(`Join your video call: ${url}`);
  descParts.push("Your appointment with your Rehab4Life180 financial wellbeing coach.");
  return {
    start,
    end,
    title,
    description: descParts.join("\\n\\n"),
    location: url || COMPANY,
  };
};

export const googleCalendarUrl = (appt) => {
  const { start, end, title, description, location } = eventFields(appt);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${fmtFloating(start)}/${fmtFloating(end)}`,
    details: description.replace(/\\n/g, "\n"),
    location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const buildIcs = (appt) => {
  const { start, end, title, description, location } = eventFields(appt);
  const stamp = fmtFloating(new Date());
  const uid = `${appt.id || Math.random().toString(36).slice(2)}@rehab4life180.com`;
  const esc = (s) => String(s).replace(/([,;])/g, "\\$1");
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Rehab4Life180//Appointments//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${fmtFloating(start)}`,
    `DTEND:${fmtFloating(end)}`,
    `SUMMARY:${esc(title)}`,
    `DESCRIPTION:${esc(description)}`,
    `LOCATION:${esc(location)}`,
    "STATUS:CONFIRMED",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
};

export const downloadIcs = (appt) => {
  const blob = new Blob([buildIcs(appt)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `rehab4life180-appointment-${appt.date || "event"}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
